export default __webpack_public_path__ + "static/media/grudzien.6a184649.mp3";